module.exports = __webpack_public_path__ + "img/181121_AWS_Türhänger_2.d37d5ece.jpg";